import React from 'react';
import { motion } from 'framer-motion';
export function ComparisonTable() {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-67">
      <div className="max-w-4xl mx-auto px-4" data-id="element-68">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-center text-charcoal mb-12" data-id="element-69">
          Wie Luisé sich zu dem verhält, was du schon probiert hast
        </h2>

        <div className="overflow-x-auto pb-4" data-id="element-70">
          <motion.table initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="w-full min-w-[600px] border-collapse bg-white shadow-sm rounded-lg overflow-hidden" data-id="element-71">
            <thead data-id="element-72">
              <tr className="border-b border-charcoal/10" data-id="element-73">
                <th className="p-4 text-left w-1/4" data-id="element-74"></th>
                <th className="p-4 text-center font-ui text-sm font-semibold text-charcoal/60 uppercase tracking-wider w-[18%]" data-id="element-75">
                  Rosmarin/ Castoröl DIY
                </th>
                <th className="p-4 text-center font-ui text-sm font-semibold text-charcoal/60 uppercase tracking-wider w-[18%]" data-id="element-76">
                  Nahrungsergänzung
                </th>
                <th className="p-4 text-center font-ui text-sm font-semibold text-charcoal/60 uppercase tracking-wider w-[18%]" data-id="element-77">
                  Minoxidil
                </th>
                <th className="p-4 text-center font-ui text-base font-bold text-charcoal uppercase tracking-wider bg-accent-light/30 border-b-2 border-accent w-[21%]" data-id="element-78">
                  Luisé
                </th>
              </tr>
            </thead>
            <tbody className="font-ui text-sm" data-id="element-79">
              <tr className="border-b border-charcoal/5" data-id="element-80">
                <td className="p-4 font-semibold text-charcoal" data-id="element-81">
                  Fettfreie Anwendung?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-82">Nein</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-83">
                  Nicht relevant
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-84">
                  Oft reizend
                </td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-85">
                  Ja
                </td>
              </tr>
              <tr className="border-b border-charcoal/5" data-id="element-86">
                <td className="p-4 font-semibold text-charcoal" data-id="element-87">
                  Erste Veränderungen
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-88">3–6 Monate</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-89">3–6 Monate</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-90">Variiert</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-91">
                  2–4 Wochen (Gefühl),
                  <br data-id="element-92" />
                  länger (sichtbar)
                </td>
              </tr>
              <tr className="border-b border-charcoal/5" data-id="element-93">
                <td className="p-4 font-semibold text-charcoal" data-id="element-94">
                  Einfach beizubehalten?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-95">Schwer</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-96">Einfach</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-97">Schwer</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-98">
                  Ja
                </td>
              </tr>
              <tr className="border-b border-charcoal/5" data-id="element-99">
                <td className="p-4 font-semibold text-charcoal" data-id="element-100">
                  Direkt auf die Kopfhaut?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-101">Manchmal</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-102">Nein</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-103">Ja</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-104">
                  Ja
                </td>
              </tr>
              <tr data-id="element-105">
                <td className="p-4 font-semibold text-charcoal" data-id="element-106">
                  Beauty-freundlich?
                </td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-107">Selten</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-108">Ja</td>
                <td className="p-4 text-center text-charcoal/70" data-id="element-109">Nein</td>
                <td className="p-4 text-center font-semibold text-charcoal bg-accent-light/30" data-id="element-110">
                  Ja
                </td>
              </tr>
            </tbody>
          </motion.table>
        </div>
      </div>
    </section>;
}